import React from "react";
import { GoBack } from "../../../components/Layout/GoBack";
import { BottomNav } from "../../../components/Nav/BottomNav";

const About = () => {
  return (
    <div>
      <div className="container px-4 pt-8 max-w-sm mx-auto relative  pb-24">
        <GoBack />

        <h2 className="font-body font-bold text-3xl mt-3">About Us</h2>

        <p className="text-sm font-body text-textGray mt-5">
          MecGlobal is a Canada-based company that relocated to Australia where
          they now operate crypto investment services. The company is engaged in
          trading, mining, technology and manufacturing which generate
          substantial profits and income. MecGlobal also specializes in
          collecting metal scrap and industrial wastes discharged from
          corporations or dismantled properties, transporting them to
          intermediate treatment plants owned by subsidiaries. The company's
          products include industrial waste materials such as copper and
          aluminum, which generate wonderful returns to support amazing profits
          for investors. MecGlobal operates worldwide.
        </p>

        <div className="mt-5">
          <p className="text-xs font-body text-textGray">
            Company headquarters @
          </p>
          <p className="text-xs font-body text-textGray">Macpherson Street</p>
          <p className="text-xs font-body text-textGray">Carnamah 6.c6517</p>
          <p className="text-xs font-body text-textGray">Australia</p>
        </div>
      </div>
      <div className=" max-w-sm mx-auto w-full ">
        <BottomNav />
      </div>
    </div>
  );
};

export default About;
